/**
 * @group Data
 * @summary Consultation status values for patient telehealth sessions
 *
 * @remarks
 * This constant contains the possible status values for patient consultations,
 * used to track the lifecycle of telehealth sessions from scheduling to completion.
 *
 * @example
 * ```typescript
 * import { CONSULTATION_STATUS } from '@shared/constants';
 *
 * function isActiveConsultation(status: string): boolean {
 *   return status === CONSULTATION_STATUS.IN_PROGRESS;
 * }
 *
 * function isCompletedConsultation(status: string): boolean {
 *   return status === CONSULTATION_STATUS.COMPLETED;
 * }
 * ```
 */
export const CONSULTATION_STATUS = {
  SCHEDULED: 'scheduled',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  WAITING: 'waiting',
} as const;
